module.exports = __webpack_public_path__ + "media/customizations/regencyatmontaine/logo-24020b50498ec02c004772cd6da04ffc.png";